import React, { useState, useRef, useEffect } from "react";
import ScrollRef from "../../detail-components/ScrollRef";
import jsonParser from "../helper/jsonParser";

import BackgroundImageFromUrl from "../../components/parseImage/BackgroundImageFromUrl";
import { checkImage } from "../../constants/checkImage";
import ConstantStrings from "../../constants/ConstantStrings";
import { loadWidthImage } from "../../constants/loadWidthImage";
import { cacheImage, getCacheImage, getImageUrl } from "../helper/parseImage";
import MainContent1Title from "./MainContent1Title";
import AudioIcon, { useAutoPlayAudio, handleClickAudio } from "./Assets/AudioIcon";

const MainContent5ImageTextNormal = ({ data, isLast, playingAudioRef }) => {
  const content = data?.content;
  const contentText =
    content?.texts[0] !== null &&
    content?.texts[0] !== undefined &&
    content?.texts[0]?.length > 0
      ? jsonParser(content?.texts[0])
      : content?.texts[0];

  var imageStyle = {
    width: "calc((100% - 5rem)/2)",
  };
  const [isLoading, setIsLoading] = useState(
    checkImage(content?.images[0])
      ? getCacheImage([content?.images[0]])
        ? false
        : true
      : false
  );
  var key = getImageUrl(content?.images[0]);
  useEffect(() => {
    loadWidthImage(key, (err, img) => {
      cacheImage([key]);
      setIsLoading(false);
    });
  }, [key]);

  const audioLink = content?.audioLink;
  const audioRef = useRef(new Audio(ConstantStrings.IMAGE_URL + audioLink));
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);

  useAutoPlayAudio({
    content,
    audioRef,
    playingAudioRef,
    setIsAudioPlaying,
    slideId: data?._id || data.questionId,
    type: 0
  });

  return (
    <div
      className="m-auto"
      style={{
        borderRadius: "1rem",
        maxWidth: "40rem",
        textAlign: "center",
      }}
    >
      {!isLast && !isLoading && <ScrollRef />}
      {isLoading && <div>Loading</div>}
      {data?.title && !isLoading && <MainContent1Title title={data?.title} />}
      <BackgroundImageFromUrl
        className={`content-image-text columns is-centered m-auto is-align-items-center`}
        style={{
          gap: "5rem",
          maxWidth: "40rem",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
          borderRadius: "1rem",
        }}
        objectId={content?.backgroundImage}
      >
        <img src={key} style={imageStyle} onError={(e)=>{ e.target.src = ConstantStrings.DEFAULT_IMAGE;e.target.style.width = "2.5rem";e.target.style.height = "2.5rem"; }} alt={content?.images[0]} />
        <div
          className={`${
            isLoading ? "is-hidden" : ""
          } content-text is-centered column is-half has-text-kurio-main-color-black`}
          style={{
            textAlign: "left",
            width: "calc((100% - 5rem)/2)",
          }}
        >
          {audioLink && playingAudioRef && <AudioIcon isPlaying={isAudioPlaying} onClick={() => handleClickAudio(audioRef, setIsAudioPlaying)} />}
          {contentText}
        </div>
      </BackgroundImageFromUrl>
    </div>
  );
};

export default MainContent5ImageTextNormal;
